import { gql } from '@apollo/client';

export default gql`
  query activeCheckoutAttempt($cartId: ID!) {
    activeCheckoutAttempt(cartId: $cartId) {
      id
      state
      message
      taxQuoteId
      deliveryMethod
      shippingAddress
      reconciliationRequiredAt
      orderId
    }
  }
`;
